import { useEffect, useState } from 'react';
import { getReverseAddressParams } from './useValidateAddressPayloadFromParams.utils';
import { IReversedAddress } from './useValidateAddressPayloadFromParams.models';
import { IInputs } from '@vfit/shared/models';
import { getAddressFromLatLng, VALIDATE_ADDRESS_PAYLOAD } from '@vfit/consumer/data-access';

export const useValidateAddressPayloadFromParams = () => {
  const [address, setAddress] = useState<IReversedAddress>();

  useEffect(() => {
    if (address && Object?.keys(address)?.length > 0) {
      if (address?.lat && address?.lon) {
        getAddressFromLatLng(parseFloat(address.lat || '0'), parseFloat(address.lon || '0')).then(
          (res) => {
            let stateOrProvince = '';
            res['address_components'].forEach((v: any) => {
              if (v.types.includes('administrative_area_level_2')) stateOrProvince = v.short_name;
            });
            const validateAddressPayload: IInputs = {
              ...(address?.city && { city: address.city }),
              ...(address?.postalCode && { postalCode: address.postalCode }),
              ...(address?.street && { street: address.street }),
              ...(address?.streetNumber && { streetNumber: address.streetNumber }),
              ...((stateOrProvince || address?.stateOrProvince) && {
                stateOrProvince: address?.stateOrProvince || stateOrProvince,
              }),
              ...((stateOrProvince || address?.displayStateOrProvince) && {
                displayStateOrProvince: address?.displayStateOrProvince || stateOrProvince,
              }),
              ...(address?.lat && { latitude: address.lat }),
              ...(address?.lon && { longitude: address.lon }),
            };
            if (validateAddressPayload?.latitude && validateAddressPayload?.longitude) {
              localStorage.setItem(
                VALIDATE_ADDRESS_PAYLOAD,
                JSON.stringify(validateAddressPayload)
              );
            }
          }
        );
      }
    }
  }, [address]);

  useEffect(() => {
    setAddress(getReverseAddressParams() as unknown as IReversedAddress);
  }, []);

  return null;
};
